/**
 * @fileoverview Renewals timeline component
 * @module TechStackAnalysis/components/RenewalsTimeline
 */

import React from 'react';
import { Calendar } from 'lucide-react';

/**
 * Format currency value
 * @param {number} value - Value to format
 * @returns {string} Formatted currency string
 */
const formatCurrency = (value) => {
  if (!value) return '$0';
  if (value >= 1e6) return `$${(value / 1e6).toFixed(1)}M`;
  if (value >= 1e3) return `$${(value / 1e3).toFixed(0)}K`;
  return `$${value.toLocaleString()}`;
};

/**
 * Parse date into month/day
 * @param {string} dateStr - Date string
 * @returns {Object} Object with month and day
 */
const parseDate = (dateStr) => {
  if (!dateStr) return { month: '---', day: '--' };
  const date = new Date(dateStr);
  return {
    month: date.toLocaleDateString('en-US', { month: 'short' }),
    day: date.getDate()
  };
};

/**
 * Individual renewal item
 */
const RenewalItem = ({ renewal }) => {
  const { month, day } = parseDate(renewal.date);

  return (
    <div className={`ts-renewal-item urgency-${renewal.urgency || 'low'}`}>
      <div className="ts-renewal-date">
        <span className="ts-renewal-date-month">{month}</span>
        <span className="ts-renewal-date-day">{day}</span>
      </div>
      <div className="ts-renewal-content">
        <p className="ts-renewal-vendor">{renewal.vendorName}</p>
        <p className="ts-renewal-description">{renewal.description}</p>
      </div>
      <div className="ts-renewal-amount">
        {formatCurrency(renewal.amount)}
      </div>
    </div>
  );
};

/**
 * Renewals timeline section
 * @param {Object} props
 * @param {Array} props.renewals - Array of renewal objects
 */
const RenewalsTimeline = ({ renewals }) => {
  if (!renewals || renewals.length === 0) return null;

  return (
    <div className="ts-renewals-section">
      <div className="ts-renewals-header">
        <div className="ts-renewals-title">
          <Calendar size={18} />
          <span>Upcoming Renewals</span>
        </div>
      </div>
      <div className="ts-renewals-list">
        {renewals.slice(0, 5).map((renewal, index) => (
          <RenewalItem key={index} renewal={renewal} />
        ))}
      </div>
    </div>
  );
};

export default RenewalsTimeline;
